<template>
  <el-table-column
    prop="is_active"
    sortable="custom"
    label="Státusz"
    show-overflow-tooltip
    min-width="100"
  >
    <template slot-scope="scope">
      <el-tag v-if="scope.row.is_active" type="success" size="small">Aktív</el-tag>
      <el-tag v-if="!scope.row.is_active" type="danger" size="small">Inaktív</el-tag>
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'is_active',
  };
</script>
